import styled from "styled-components";
import { Icon, Tooltip, TooltipProps } from "@introist/react-foundation/v2";

const IconWrapper = styled.div<{ filled?: boolean }>`
  display: grid;

  > svg {
    fill: var(--palette-foreground-dimmed) !important;
    stroke: ${({ filled }) =>
      filled === false ? "var(--palette-foreground-dimmed) !important;" : undefined};
  }
`;

export const InfoTooltip = (props: TooltipProps & { filled?: boolean }) => (
  <Tooltip {...props}>
    <IconWrapper filled={props.filled}>
      <Icon name={props.filled === false ? "info" : "infoFilled"} />
    </IconWrapper>
  </Tooltip>
);
